export default function checkLogin() {
  return !!localStorage.getItem('adminToken');
}